/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { EmplacementStockDto } from '../models/emplacement-stock-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des emplacements de stock
 */
@Injectable({
  providedIn: 'root',
})
export class EmplacementsStockService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation emplacementStockGetList
   */
  static readonly EmplacementStockGetListPath = '/api/emplacements-stock/list';

  /**
   * Renvoie la liste des emplacements de stock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `emplacementStockGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  emplacementStockGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<EmplacementStockDto>>> {

    const rb = new RequestBuilder(this.rootUrl, EmplacementsStockService.EmplacementStockGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EmplacementStockDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des emplacements de stock.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `emplacementStockGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  emplacementStockGetList(params?: {
  }): Observable<Array<EmplacementStockDto>> {

    return this.emplacementStockGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EmplacementStockDto>>) => r.body as Array<EmplacementStockDto>)
    );
  }

  /**
   * Path part for operation emplacementStockLoadList
   */
  static readonly EmplacementStockLoadListPath = '/api/emplacements-stock/load-list';

  /**
   * Renvoie la liste des emplacements de stock (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `emplacementStockLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  emplacementStockLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, EmplacementsStockService.EmplacementStockLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des emplacements de stock (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `emplacementStockLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  emplacementStockLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.emplacementStockLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation emplacementStockGet
   */
  static readonly EmplacementStockGetPath = '/api/emplacements-stock/{id}';

  /**
   * Renvoie l'emplacement de stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `emplacementStockGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  emplacementStockGet$Response(params: {

    /**
     * Identifiant de l&#x27;emplacement de stock
     */
    id: number;
  }): Observable<StrictHttpResponse<EmplacementStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, EmplacementsStockService.EmplacementStockGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmplacementStockDto>;
      })
    );
  }

  /**
   * Renvoie l'emplacement de stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `emplacementStockGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  emplacementStockGet(params: {

    /**
     * Identifiant de l&#x27;emplacement de stock
     */
    id: number;
  }): Observable<EmplacementStockDto> {

    return this.emplacementStockGet$Response(params).pipe(
      map((r: StrictHttpResponse<EmplacementStockDto>) => r.body as EmplacementStockDto)
    );
  }

  /**
   * Path part for operation emplacementStockPut
   */
  static readonly EmplacementStockPutPath = '/api/emplacements-stock/{id}';

  /**
   * Met à jour l'emplacement de stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `emplacementStockPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  emplacementStockPut$Response(params: {

    /**
     * Identifiant de l&#x27;emplacement de stock à mettre à jour
     */
    id: number;

    /**
     * Emplacement de stock
     */
    body: EmplacementStockDto
  }): Observable<StrictHttpResponse<EmplacementStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, EmplacementsStockService.EmplacementStockPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmplacementStockDto>;
      })
    );
  }

  /**
   * Met à jour l'emplacement de stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `emplacementStockPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  emplacementStockPut(params: {

    /**
     * Identifiant de l&#x27;emplacement de stock à mettre à jour
     */
    id: number;

    /**
     * Emplacement de stock
     */
    body: EmplacementStockDto
  }): Observable<EmplacementStockDto> {

    return this.emplacementStockPut$Response(params).pipe(
      map((r: StrictHttpResponse<EmplacementStockDto>) => r.body as EmplacementStockDto)
    );
  }

  /**
   * Path part for operation emplacementStockDelete
   */
  static readonly EmplacementStockDeletePath = '/api/emplacements-stock/{id}';

  /**
   * Supprime l'emplacement de stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `emplacementStockDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  emplacementStockDelete$Response(params: {

    /**
     * Identifiant de l&#x27;emplacement de stock à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, EmplacementsStockService.EmplacementStockDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'emplacement de stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `emplacementStockDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  emplacementStockDelete(params: {

    /**
     * Identifiant de l&#x27;emplacement de stock à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.emplacementStockDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation emplacementStockPost
   */
  static readonly EmplacementStockPostPath = '/api/emplacements-stock';

  /**
   * Crée l'emplacement de stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `emplacementStockPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  emplacementStockPost$Response(params: {

    /**
     * Emplacement de stock
     */
    body: EmplacementStockDto
  }): Observable<StrictHttpResponse<EmplacementStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, EmplacementsStockService.EmplacementStockPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EmplacementStockDto>;
      })
    );
  }

  /**
   * Crée l'emplacement de stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `emplacementStockPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  emplacementStockPost(params: {

    /**
     * Emplacement de stock
     */
    body: EmplacementStockDto
  }): Observable<EmplacementStockDto> {

    return this.emplacementStockPost$Response(params).pipe(
      map((r: StrictHttpResponse<EmplacementStockDto>) => r.body as EmplacementStockDto)
    );
  }

}
